import i18n from "@/restricted-library/i18n";
import store from "@/restricted-library/store";
import Vue from "vue";
import Router from "vue-router";

import { getKeycloak } from "@/restricted-library/plugins/keycloak";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("./views/Login.vue")
    },
    {
      path: "/callback/sso",
      name: "callbackSSO",
      component: () => import("./views/KeycloakRedirect.vue")
    },
    {
      path: "/informativa",
      name: "informativa",
      component: () => import("./views/InformativaTrattamento.vue")
    },
    {
      path: "/redirect/sso/:healthCare/:function",
      name: "redirectSSO",
      component: () => import("./views/SSORedirect.vue")
    },
    {
      path: "/homepage",
      name: "homepage",
      component: () => import("./views/Homepage.vue"),
      children: [
        {
          path: "/profile",
          name: "profile",
          component: () => import("./views/sections/Profile.vue")
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("./views/sections/Dashboard.vue")
        },
        {
          path: "/centroNotifiche",
          name: "centroNotifiche",
          component: () => import("./views/sections/NotificationsCenter.vue"),
          props: true
        },
        {
          path: "/copertureMassimali",
          name: "copertureMassimali",
          component: () => import("./views/sections/CopertureMassimali.vue")
        },
        {
          path: "/richiestePrenotazioni",
          name: "richiestePrenotazioni",
          component: () => import("./views/sections/RichiestePrenotazioni.vue"),
          props: true
        },
        {
          path: "/bookingWizard",
          name: "bookingWizard",
          component: () => import("./views/sections/BookingWizard.vue"),
          props: true
        },
        {
          path: "/bookingDetails",
          name: "bookingDetails",
          component: () => import("./components/Bookings/BookingDetails.vue"),
          props: true
        },
        {
          path: "/expost",
          name: "expost",
          component: () => import("./views/sections/ExPost.vue")
        },
        {
          path: "/prestazioniEffettuate",
          name: "prestazioniEffettuate",
          component: () => import("./views/sections/PrestazioniEffettuate.vue")
        },
        {
          path: "/richiesteRimborso",
          name: "richiesteRimborso",
          component: () => import("./views/sections/RichiesteRimborso.vue")
        },
        {
          path: "/estrattoConto",
          name: "estrattoConto",
          component: () => import("./views/sections/EstrattoConto.vue")
        },
        {
          path: "/fondoEstPerTe",
          name: "fondoEstPerTe",
          component: () => import("./views/sections/FondoEstPerTe.vue")
        },
        {
          path: "/contatti",
          name: "contatti",
          component: () => import("./views/sections/Contatti.vue")
        },
        {
          path: "/gestioneFamiliari",
          name: "gestioneFamiliari",
          component: () => import("./views/sections/GestioneFamiliari.vue")
        },
        {
          path: "/versamentoVolontario",
          name: "versamentoVolontario"
          // no component is needed because is a redirect URL only
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    setTimeout(() => {
      document
        .querySelector(".v-application")
        .scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 0);
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  let necessaryForFase1 = process.env.VUE_APP_NECESSARY_FOR_FASE_1 != "false";
  let kc = getKeycloak();
  let kcToken = kc ? kc.token : null;
  if (!kcToken && !["login", "callbackSSO", "redirectSSO"].includes(to.name)) {
    store.dispatch("doLogout", null, { root: true });
  } else {
    let consentToDeclare = store.getters["login/getConsentToDeclare"];
    if (consentToDeclare && to.name !== "informativa" && to.name !== "login") {
      store.dispatch("doLogout", null, { root: true });
    }
    let appointmentId = store.getters["bookings/getCreatedAppointmentId"];
    let isReminderCompleted = store.getters["bookings/getReminderComplete"];
    if (to.name === "bookingWizard") {
      if (to.query?.q) {
        let activeStep = store.getters["bookings/getStepByName"](to.query.q);
        if (
          !appointmentId &&
          activeStep &&
          (activeStep.visited || activeStep.active)
        ) {
          next();
        } else {
          let currentStepName = store.getters["bookings/getCurrentStep"].name;
          if (currentStepName != "feedback") {
            next({ name: "bookingWizard", query: { q: currentStepName } });
          }
        }
      }
    } else if (
      necessaryForFase1 &&
      from.name === "bookingWizard" &&
      from.query.q !== "contattoDiretto" &&
      from.query.q !== "promemoria" &&
      to.name !== "bookingWizard" &&
      to.name !== "login" &&
      to.name !== "expost" &&
      to.name !== "richiestePrenotazioni" &&
      !appointmentId
    ) {
      openLeaveWizardAlertDialog(store, next);
    } else if (
      necessaryForFase1 &&
      from.name === "bookingWizard" &&
      from.query.q === "promemoria" &&
      to.name !== "bookingWizard" &&
      to.name !== "login" &&
      to.name !== "expost" &&
      !isReminderCompleted
    ) {
      openLeaveWizardAlertDialog(store, next);
    } else if (
      necessaryForFase1 &&
      from.name === "expost" &&
      to.name !== "bookingWizard" &&
      to.name !== "login" &&
      to.name === "richiestePrenotazioni" &&
      !appointmentId
    ) {
      // leave dialog if to.name goes to expost
      openLeaveExPostAlertDialog(store, next);
    } else {
      next();
    }
  }
});

const openLeaveWizardAlertDialog = function (store, next) {
  if (store) {
    store.commit(
      "baseDialog/openDialog",
      {
        title: i18n.t("dialog.alerts.leaveWizard.title"),
        buttons: [
          {
            text: i18n.t("dialog.alerts.leaveWizard.cancel"),
            outlined: true,
            action: () => {
              store.commit("baseDialog/reset", null, { root: true });
            }
          },
          {
            text: i18n.t("dialog.alerts.leaveWizard.forward"),
            action: () => {
              next();
              store.commit("baseDialog/reset", null, { root: true });
            }
          }
        ]
      },
      { root: true }
    );
  }
};

const openLeaveExPostAlertDialog = function (store, next) {
  if (store) {
    store.commit(
      "baseDialog/openDialog",
      {
        title: i18n.t("dialog.alerts.leaveWizardForExPost.title"),
        buttons: [
          {
            text: i18n.t("dialog.alerts.leaveWizardForExPost.cancel"),
            outlined: true,
            action: () => {
              store.commit("baseDialog/reset", null, { root: true });
            }
          },
          {
            text: i18n.t("dialog.alerts.leaveWizardForExPost.forward"),
            action: () => {
              next();
              store.commit("baseDialog/reset", null, { root: true });
            }
          }
        ]
      },
      { root: true }
    );
  }
};

export default router;
